import React, {useState, useEffect, useRef} from "react";

//Image mobile

import src from "../images/masthead.jpg";
import srcRet from "../images/masthead@2x.jpg";
import webp from "../images/masthead.webp";
import webpRet from "../images/masthead@2x.webp";

import mobile from "../images/mobile/masthead.webp";

import styles from "./Masthead.module.scss";
import Button from "./Global/Button";

import MastheadBackground from "./MastheadBackground";
import Image from "./Global/Image";
import gsap from "gsap";
import isMobile from "ismobilejs";
import Map from "./Elements/Map";
import Scrollbar from "smooth-scrollbar";

export default function Masthead() {
    const button = useRef(null);
    const figure1 = useRef(null);
    const figure2 = useRef(null);

    const [sbMap, setSbMap] = useState();
    const [limitX, setLimitX] = useState(null);

    const map = useRef(null);
    const scrollbar = useRef(null);

    useEffect(() => {
        scrollEvent();
        window.addEventListener('scroll', () => scrollEvent(), {passive: true}, true);
    }, []);

    useEffect(() => {


        const smoothScrollEvent = (status) => {
            if (scrollbar.current) scrollbar.current.value = status.offset.x;
        };

        if (!limitX || limitX === Infinity) {


            setTimeout(() => {
                setSbMap(() => Scrollbar.init(map.current, {}));
                if (sbMap) setLimitX(() => sbMap.limit.x)
            }, 500);


            if (sbMap) sbMap.addListener(smoothScrollEvent);

        }

        return (() => {
            if (sbMap && limitX) sbMap.removeListener(smoothScrollEvent)
        })
    }, [sbMap, limitX]);

    const scrollEvent = () => {
        const buttonLink = button.current.querySelector('a');

        const title = document.querySelector('h1');
        const image = document.getElementsByClassName(styles.ImageWrapper)[0];

        if (!isMobile().phone) {
            if (title.getBoundingClientRect().bottom <= image.getBoundingClientRect().top) {

                gsap.set(title, {
                    y: window.scrollY * -.6
                });
            }

            if (window.scrollY > 0) {
                gsap.set([buttonLink], {
                    position: 'fixed',
                    onComplete: () => {
                        buttonLink.classList.add('stuck');

                        gsap.to(buttonLink, 1, {
                            top: window.innerHeight - (buttonLink.getBoundingClientRect().height + 40),
                            left: window.innerWidth - (buttonLink.getBoundingClientRect().width + 40),
                        })
                    }
                })
            }

            if (buttonLink.getBoundingClientRect().bottom > document.querySelector('footer').getBoundingClientRect().top) {
                gsap.to(buttonLink, .3, {
                    opacity: 0
                })
            } else {
                gsap.to(buttonLink, .3, {
                    opacity: 1
                })
            }
        }

        if (!isMobile().phone) {
            if (image.getBoundingClientRect().top < window.innerHeight && image.getBoundingClientRect().bottom > 0) {
                gsap.set(figure1.current, {
                    y: (window.innerHeight - image.getBoundingClientRect().top) * .2
                });

                gsap.set(figure2.current, {
                    y: (window.innerHeight - image.getBoundingClientRect().top) * .4
                });
            }
        }
    };

    return (
        <section className={styles.Main}>
            <div className={styles.Masthead}>
                <MastheadBackground headText={styles.ImageWrapper}/>

                <div className="container">
                    <div className={styles.Content}>
                        <div className={styles.Title}>
                            <h1>
                                <strong>
                                    Jeux vidéo,
                                </strong>
                                un marché de masse en plein boom !
                            </h1>

                            <div className={styles.ButtonWrapper} ref={button}>
                                <Button url={"https://ad.doubleclick.net/ddm/clk/511981132;319233803;y"}
                                        text={'Investissez'}/>
                            </div>
                        </div>

                        <div className={styles.HeadText}>
                            Considéré initialement comme un secteur d’activité réservé aux « geeks », les jeux vidéo ont progressivement élargi leur public ces dernières années… Grâce aux avancées technologiques, à la mobilité et plus récemment aux plateformes, le profil des gamers, moins masculin et plus âgé, n’a cessé d’évoluer. Au point de transformer le secteur de manière spectaculaire en un marché global. L’arrivée des GAFA dans la partie indique que le jeu reste ouvert et plus que jamais interconnecté.
                            <br/><br/>
                            Que le meilleur gagne !
                        </div>
                    </div>
                </div>

                <div className={styles.ImageWrapper}>

                    <div ref={figure2} className={styles.Figures}>
                        <span>2,7</span>
                        milliards de <br/>
                        joueurs en 2021
                    </div>

                    <div ref={figure1} className={styles.Figures}>
                        <span>300</span>
                        milliards de dollars <br/>
                        de recettes
                    </div>


                    <Image {...{src, srcRet, webp, webpRet, mobile}}>
                        <p>
                            <strong>Alors qu’elle pèse désormais plus lourd que celles du cinéma et de la musique
                                réunies,
                                l’industrie du jeu vidéo ne s’est jamais aussi bien portée.</strong>
                        </p>

                        <p>
                            Au niveau mondial, le marché a atteint le cap symbolique des 300 milliards de dollars de
                            recettes, avec 2,7 milliards de joueurs, selon une étude publiée fin avril 2021 par le
                            cabinet de conseil Accenture. Une tendance qui devrait se poursuivre puisque 400 millions de
                            gamers supplémentaires sont attendus d’ici fin 2023, ce qui portera le total à 3,1 milliards
                            dans le monde.
                        </p>
                    </Image>
                </div>
            </div>
            <div className={styles.PlayerMap}>
                <div className="container">
                    <h2>
                        Qui sont les 2,7 milliards <br/> <strong>de joueurs aujourd’hui ?</strong>
                    </h2>
                </div>

                <div className={styles.MapWrapper}>
                    <div className={styles.Map} ref={map}>
                        <Map/>
                    </div>

                    {sbMap && limitX > 0 && limitX !== Infinity ?
                        <input className="custom-scrollbar" type="range" min="0" defaultValue={0} max={limitX}
                               ref={scrollbar}
                               onChange={(e) => {
                                   sbMap.setPosition(e.target.value, 0)
                               }}
                        />
                        : null}

                    <div className={styles.MapText}>
                        <p>
                            Les quatre plus grands marchés du jeu : la Chine, le Japon, les Etats-Unis et le
                            Royaume-Uni. Cumulés, ils représentent 47 % des joueurs dans le monde et 64 % de toutes les
                            dépenses directes des consommateurs dans le domaine.
                        </p>

                        <p>
                            La France fait partie des 14 pays, avec l’Espagne, l’Italie ou encore le Canada où
                            l’industrie se développe à une vitesse fulgurante.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}
